import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';

import {select, Store} from '@ngrx/store';
import * as moment from 'moment';

import {
    getCommandFailedCount,
    getCommandFailedState,
    getCommandQueue,
    getCommandQueueCount,
    getCommandStackCount,
    getCommandStackState,
    getQueryFailedCount,
    getQueryFailedState,
    getQueryQueueCount,
    getQueryQueueState,
    getQueryStackCount,
    getQueryStackState,
    getSyncActive,
    NgrxManagerState
} from '../reducer';
import {NgrxManagerService} from '../ngrx-manager.service';
import {Request} from '../model';
import {ActivatedRoute, Router} from '@angular/router';
import * as actions from '../actions';
import {getCurrentLanguage, getTranslationInfoSichtbar, LanguageState} from '@softwarepioniere/language';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'ngrx-manager-sync-admin-dialog',
    templateUrl: './sync-admin-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SyncAdminDialogComponent implements OnInit, OnDestroy {
    isOnline$: Observable<Boolean>;


    lang = new Subject<string>();
    lang$: Observable<string>;
    translationInfoSichtbar$: Observable<boolean>;

    requestStackServiceIsEnabled$: Observable<boolean>;
    commandStackCount$: Observable<Number>;
    commandQueueCount$: Observable<Number>;
    commandFailedCount$: Observable<Number>;

    queryStackCount$: Observable<Number>;
    queryQueueCount$: Observable<Number>;
    queryFailedCount$: Observable<Number>;

    commandStack$: Observable<Request[]>;
    commandQueue$: Observable<Request[]>;
    commandFailed$: Observable<Request[]>;

    queryStack$: Observable<Request[]>;
    queryQueue$: Observable<Request[]>;
    queryFailed$: Observable<Request[]>;

    syncActive$: Observable<boolean>;

    public returnUrl: string;
    public queryParams: Subscription;

    constructor(public router: Router,
                public route: ActivatedRoute,
                public storeNgrxClientManager: Store<NgrxManagerState>,
                public langStore: Store<LanguageState>,
                public translate: TranslateService,
                private ngrxManagerService: NgrxManagerService) {
        this.translate.setDefaultLang('de');
        this.lang$ = langStore.pipe(select(getCurrentLanguage));
    }

    async goBack() {
        await this.router.navigate([this.returnUrl]);
    }

    async abbrechen() {
        await this.goBack();
    }

    ngOnDestroy(): void {
        if (this.queryParams != null) {
            this.queryParams.unsubscribe();
        }
    }

    ionViewWillLeave(): void {
        if (this.queryParams != null) {
            this.queryParams.unsubscribe();
        }
    }

    async ionWillOpen() {
    }

    ionDidOpen() {

    }

    restartApplication() {
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.returnUrl = params.returnUrl;
        });

        this.translationInfoSichtbar$ = this.langStore.pipe(select(getTranslationInfoSichtbar));
        this.lang$.subscribe(lang => {
            this.translate.use(lang);
            moment.locale(lang);
        });

        // COMMAND
        this.requestStackServiceIsEnabled$ = this.ngrxManagerService.isEnabled$();
        this.commandStackCount$ = this.storeNgrxClientManager.pipe(select(getCommandStackCount));
        this.commandQueueCount$ = this.storeNgrxClientManager.pipe(select(getCommandQueueCount));
        this.commandFailedCount$ = this.storeNgrxClientManager.pipe(select(getCommandFailedCount));
        this.commandStack$ = this.storeNgrxClientManager.pipe(select(getCommandStackState));
        this.commandQueue$ = this.storeNgrxClientManager.pipe(select(getCommandQueue));
        this.commandFailed$ = this.storeNgrxClientManager.pipe(select(getCommandFailedState));

        // QUERY
        this.queryStackCount$ = this.storeNgrxClientManager.pipe(select(getQueryStackCount));
        this.queryQueueCount$ = this.storeNgrxClientManager.pipe(select(getQueryQueueCount));
        this.queryFailedCount$ = this.storeNgrxClientManager.pipe(select(getQueryFailedCount));
        this.queryStack$ = this.storeNgrxClientManager.pipe(select(getQueryStackState));
        this.queryQueue$ = this.storeNgrxClientManager.pipe(select(getQueryQueueState));
        this.queryFailed$ = this.storeNgrxClientManager.pipe(select(getQueryFailedState));

        this.syncActive$ = this.storeNgrxClientManager.pipe(select(getSyncActive));
    }

    async datenSenden() {
        await this.storeNgrxClientManager.dispatch(new actions.CommandQueueNextAction());
    }

    async syncStart() {
        await this.storeNgrxClientManager.dispatch(new actions.StartSyncAction());
    }

    async syncStop() {
        await this.storeNgrxClientManager.dispatch(new actions.StopSyncAction());
    }


    async play(request: Request) {
        // console.log(request);
        // await this.storeNgrxClientManager.dispatch(new actions.CommandQueueNextAction());
    }

    // SEND
    async sendQueryStackRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.SendQueryStackRequestAction(request, i));
    }

    async sendQueryQueueRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.SendQueryQueueRequestAction(request, i));
    }

    async sendQueryFailedRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.SendQueryFailedRequestAction(request, i));
    }

    async sendCommandStackRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.SendCommandStackRequestAction(request, i));
    }

    async sendCommandQueueRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.SendCommandQueueRequestAction(request, i));
    }

    async sendCommandFailedRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.SendCommandFailedRequestAction(request, i));
    }


    // DELETE
    async deleteQueryStackRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.DeleteQueryStackRequestAction(request, i));
    }

    async deleteQueryQueueRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.DeleteQueryQueueRequestAction(request, i));
    }

    async deleteQueryFailedRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.DeleteQueryFailedRequestAction(request, i));
    }

    async deleteCommandStackRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.DeleteCommandStackRequestAction(request, i));
    }

    async deleteCommandQueueRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.DeleteCommandQueueRequestAction(request, i));
    }

    async deleteCommandFailedRequest(request: Request, i: number) {
        await this.storeNgrxClientManager.dispatch(new actions.DeleteCommandFailedRequestAction(request, i));
    }

}

